import axios from "../../../services/axios-config.js";

export async function getCommissionedCompanies({ commissionedId }) {
  const res = await axios.get(`/commissioned/${commissionedId}/companies`);
  return res?.data || [];
}
